let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1XsUk")).then(() => parcelRequire('ds5JQ'));